import { render, staticRenderFns } from "./list.vue?vue&type=template&id=5d2dee57&scoped=true"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"
import style0 from "./list.vue?vue&type=style&index=0&id=5d2dee57&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d2dee57",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d2dee57')) {
      api.createRecord('5d2dee57', component.options)
    } else {
      api.reload('5d2dee57', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=5d2dee57&scoped=true", function () {
      api.rerender('5d2dee57', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ezpay/agent-merchant/list.vue"
export default component.exports